import { proxy } from 'valtio';

/**
 * 单段录音时长 store（最细粒度）
 * 每次 startRecording 时归零并开始计时，stopRecording 时停止
 * 停止后 currentDuration 保留供上报读取，上报完毕后 reset
 * 
 * 与其他两个时长 store 的关系：
 * - RecordingDurationStore：全局累计用量，同步远端限额
 * - MeetingDurationStore：当前会议累计时长，UI 外显（支持暂停/恢复）
 * - SegmentDurationStore（本 store）：单段录音精确秒数，用于增量上报
 */
export const SegmentDurationStore = proxy({
  /** 本段录音已计时秒数 */
  currentDuration: 0,
  /** 定时器 id */
  _timerId: null as number | null,
});

/** 开始计时（每次开始录音时调用，自动归零） */
export function startSegmentTimer() {
  // 先清理可能残留的定时器
  if (SegmentDurationStore._timerId !== null) {
    clearInterval(SegmentDurationStore._timerId);
  }
  SegmentDurationStore.currentDuration = 0;
  SegmentDurationStore._timerId = window.setInterval(() => {
    SegmentDurationStore.currentDuration += 1;
  }, 1000);
}

/** 停止计时（停止录音时调用，保留 currentDuration 供上报读取） */
export function stopSegmentTimer() {
  if (SegmentDurationStore._timerId !== null) {
    clearInterval(SegmentDurationStore._timerId);
    SegmentDurationStore._timerId = null;
  }
}

/** 重置（上报完毕或新会议时调用） */
export function resetSegmentTimer() {
  stopSegmentTimer();
  SegmentDurationStore.currentDuration = 0;
}
